import Vue from 'vue';
import Vuex from 'vuex';

import login from './modules/login';
import user from './modules/user';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    currentWorkUnitId: 16,
    projectName: '',
    sidebar: {
      isCollapse: false,
    },
    fullscreen: false,
  },
  getters: {
    isSidebarCollapse: state => state.sidebar.isCollapse,
    isFullscreen: state => state.fullscreen,
    currentStationName(state) {
      const u = (state.user && state.user.workUnits && state.user.workUnits.find(
        (item) => item.workUnitId === state.currentWorkUnitId,
      ));
      return u ? u.workUnitName : '';
    },
    currentStationCode(state) {
      const u = (state.user && state.user.workUnits && state.user.workUnits.find(
        (item) => item.workUnitId === state.currentWorkUnitId,
      ));
      return u ? u.workUnitCode : '';
    },
    currentStationOps(state) {
      const workUnits = state.user && state.user.workUnits && state.user.workUnits.find(
        (item) => item.workUnitId === state.currentWorkUnitId
      );
      if (workUnits && workUnits.grantedOperates) {
        return workUnits.grantedOperates;
      }
      return [];
    },
    hasControlPermission(state) {
      let userProfile = {};
      try {
        const p = (state.user && state.user.userProfile) || JSON.parse(localStorage.getItem('userProfile') || '{}');
        userProfile = p || {};
      } catch (e) {}

      const account = String(userProfile.account || userProfile.username || localStorage.getItem('userAccount') || '').trim();
      const realName = String(userProfile.realName || userProfile.nickName || userProfile.nickname || userProfile.name || '').trim();

      // 允许控制的人员白名单：仅超级管理员 (admin) 以及 班组管理人员（秦旭、张林、黄春、张顺波）
      const ALLOWED_ACCOUNTS = ['admin', '002884', '003851', '004287', '004169'];
      const ALLOWED_NAMES = ['秦旭', '张林', '黄春', '张顺波', '超级管理员', '系统管理员'];

      if (ALLOWED_ACCOUNTS.includes(account) || ALLOWED_NAMES.includes(realName)) {
        return true;
      }
      return false;
    },
    hasExportPermission(state) {
      const workUnits = state
        .user.workUnits.find((item) => item.workUnitId === state.currentWorkUnitId);
      if (workUnits) {
        const { grantedOperates } = workUnits;
        return grantedOperates.includes('export');
      }
      return false;
    },
  },
  mutations: {
    TOGGLE_SIDEBAR(state) {
      state.sidebar.isCollapse = !state.sidebar.isCollapse;
    },
    SET_SIDEBAR(state, status) {
      state.sidebar.isCollapse = status;
    },
    TOGGLE_FULLSCREEN(state) {
      state.fullscreen = !state.fullscreen;
    },
    changeStationID(state, id) {
      const stationID = Number(id);
      state.currentWorkUnitId = stationID;
      localStorage.setItem('currentWorkUnitId', stationID);
    },
  },
  actions: {
    changeStation({ commit }, payload) {
      commit(payload);
    },
    toggleSidebar({ commit }) {
      commit('TOGGLE_SIDEBAR');
    },
  },
  modules: {
    login,
    user,
  },
});
